import React, { useContext } from 'react';
import gql from 'graphql-tag';
import { Mutation } from '@apollo/client/react/components';
import { t } from '@lingui/macro';
import { Trans } from '@lingui/react';
import Button from '@components/buttons';
import { Box, Flex } from '@components/layout/Grid';
import { H4 } from '@components/typography/Headings';
import { P } from '@components/typography/Paragraph';
import { Body, Header, Footer, Modal } from './base';
import { snackbarVar } from '@lib/apollo/policies';
import LanguageContext from '@lib/contexts/languageContext';
import AnalyticsManager from '@lib/analytics/manager';

const DELETE_PLAYLIST = gql`
  mutation deletePlaylist($id: ID!) {
    deletePlaylist(id: $id) {
      status {
        destroyed
      }
    }
  }
`;

const ConfirmDeletePlaylistModal = props => {
  const locale = useContext(LanguageContext);

  return (
    <React.Fragment>
      <Modal open={props.open} handleClose={props.handleClose}>
        <Header handleClose={props.handleClose}>
          <Box as={H4} mt="0px" mb="0px">
            <Trans
              id="confirm_delete_playlist_modal.title"
              message={'Delete Playlist'}
            />
          </Box>
        </Header>
        <Body pushFooterDown={210}>
          <Box mb={30}>
            <Box as={P} mt="0px" mb="0px" color="#242424">
              <Trans
                id="confirm_delete_playlist_modal.description"
                components={[<b key="0"></b>]}
                values={{
                  title: props.playlistTitle,
                  videos_count: props.playlistVideoCount,
                }}
              />
            </Box>
          </Box>
        </Body>
        <Footer>
          <Flex flexDirection="column" flex={1}>
            <Box mb={10} flex={1}>
              <Button
                appearance="default-blue"
                fullWidth
                onClick={props.handleClose}
              >
                <Trans
                  id="confirm_delete_playlist_modal.no"
                  message={'No, keep the playlist'}
                />
              </Button>
            </Box>
            <Box flex={1}>
              <Mutation mutation={DELETE_PLAYLIST}>
                {deletePlaylist => {
                  return (
                    <Button
                      fullWidth
                      appearance="outline"
                      onClick={() => {
                        deletePlaylist({
                          variables: { id: props.playlistId },
                          update: proxy => {
                            delete proxy.data.data[props.playlistId];
                          },
                        }).then(() => {
                          props.handleClose();
                          // I faced this issue https://github.com/zeit/next.js/issues/5947 no solution for it yet
                          window.location.href = `/${locale}/me/playlists`;
                          snackbarVar({
                            isSnackBarOpen: true,
                            goTo: 'NONE',
                            id: 'playlist_delete',
                            snackBarMessage: t`playlist.playlist_deleted`,
                          });
                          AnalyticsManager()._PIXEL_TRACK(
                            'delete-playlist',
                            true,
                            {
                              id: props.playlistId,
                            }
                          );
                        });
                      }}
                    >
                      <Trans
                        id="confirm_delete_playlist_modal.yes"
                        message={'Yes, I want to delete the playlist'}
                      />
                    </Button>
                  );
                }}
              </Mutation>
            </Box>
          </Flex>
        </Footer>
      </Modal>
    </React.Fragment>
  );
};

export default ConfirmDeletePlaylistModal;
